/**
 * Simple route path constants
 *
 * Central place to manage all route paths in the application.
 * Import and use these constants instead of hardcoding paths.
 */
export const ROUTES = {
  // Public routes
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  REGISTER: "/register",
  REGISTRATION_SURVEY: "/registration-survey",
  EMAIL_VERIFICATION: "/verify-email",
  // Protected routes
  DASHBOARD: "/dashboard",
  MATERIOM_AI: "/materiom-ai",
  ROOT: "/",
  MATERIALS_DATABASE: "/materials-database",
  USER_DIRECTORY: "/user-directory",
  CONTRIBUTION_PORTAL: "/contribute",
  UPDATE_DETAILS: "/update-details",
  RECIPE_DETAIL: "/materials-database/recipe",
  LICENSES: "/licenses",
  // TODO: This will be deprecated once we fully deprecate the MVP frontend
  // code and it serves no more traffic.
  //
  // This is kept while any traffic is still coming from the MVP frontend, which
  // serves Materiom AI within an iframe.
  LEGACY_MATERIOM_AI: "/legacy-materiom-ai",
} as const;

/**
 * Legacy MVP routes that need to be redirected to new paths
 * These are maintained for backward compatibility with bookmarked/shared links
 */
export const LEGACY_ROUTES = {
  DATA_COMMONS: "/data-commons",
} as const;

/**
 * Default redirect path after login
 */
export const DEFAULT_REDIRECT_PATH = ROUTES.DASHBOARD;
